export enum InvoiceModeEnum {
  MANUAL = 'MANUAL',
  AUTO = 'AUTO'
}
